import script from "./PatientCol.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCol.vue?vue&type=script&setup=true&lang=js"

import "./PatientCol.vue?vue&type=style&index=0&id=4456b923&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4456b923"]])

export default __exports__